module.exports = __webpack_public_path__ + "static/img/jp7.8416576d.png";